import { global_hooks } from 'src/globals';
import Text_Input_Submit from 'components/ui/text_input/Text_Input_Submit';
import { debounce } from 'js/utils';

global_hooks.on('listing/init', init);
function init(listing) {
	const search = {
		s: '',
	};

	listing.search = search;

	if (!listing.args.search_input) return;

	init_field(listing);

	listing.hooks.on('item/init', init_item_search_data);
	listing.items.forEach(init_item_search_data);

	listing.hooks.add_filter('filter_items', (items) => {
		return get_result(items, search.s);
	});
}

function init_item_search_data(item) {
	item.search_data = item.data.title.toLowerCase();
	item.search_data += item.data.excerpt.toLowerCase();
}

function init_field(listing) {
	const input = new Text_Input_Submit(listing.args.search_input);

	const sanitize_input = (s) => {
		s = s.trim().toLowerCase();
		return s;
	};

	input.hooks.on('submit', (s) => {
		listing.search.s = sanitize_input(s);
		debounce(() => update_result(listing), 200)();
	});
}

async function update_result(listing) {
	const loading = listing.loading();

	await listing.wait_load_all();

	const items = listing.hooks.apply_filter('search_items', listing.items);

	const result = get_result(items, listing.search.s);

	loading.end(() => {
		listing.hooks.do('result/render', result);
	});
}

function get_result(items, s) {
	if (!s) return items;

	const result = [];

	items.forEach((item) => {
		if (item.search_data.includes(s)) {
			result.push(item);
		}
	});

	return result;
}
